import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'input-label',
  templateUrl: './input-label.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputLabelComponent implements OnInit {
  @Input() label: string;
  @Input() tooltip: string = null;
  @Input() required = true;

  constructor() { }

  ngOnInit(): void {
  }

}
